/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface LocalSearch
 */
export interface LocalSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof LocalSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LocalSearch
     */
    description?: TextSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof LocalSearch
     */
    idcentre?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof LocalSearch
     */
    idlieu?: Int32NullableListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof LocalSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocalSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof LocalSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof LocalSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LocalSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LocalSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LocalSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the LocalSearch interface.
 */
export function instanceOfLocalSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocalSearchFromJSON(json: any): LocalSearch {
    return LocalSearchFromJSONTyped(json, false);
}

export function LocalSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32NullableListSearchFromJSON(json['idcentre']),
        'idlieu': !exists(json, 'idlieu') ? undefined : Int32NullableListSearchFromJSON(json['idlieu']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function LocalSearchToJSON(value?: LocalSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'description': TextSearchToJSON(value.description),
        'idcentre': Int32NullableListSearchToJSON(value.idcentre),
        'idlieu': Int32NullableListSearchToJSON(value.idlieu),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

